"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgStructureOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M27 21.14V16H17v-4h11V3H4v9h11v4H5v5.14a4 4 0 102 0V18h8v3.14a4 4 0 102 0V18h8v3.14a4 4 0 102 0zM6 5h20v5H6zm2 20a2 2 0 11-2-2 2 2 0 012 2zm10 0a2 2 0 11-2-2 2 2 0 012 2zm8 2a2 2 0 112-2 2 2 0 01-2 2z" })));
}
exports.default = SvgStructureOutline;
//# sourceMappingURL=StructureOutline.js.map